<template>
  <div class="purchase-list-wrapper"  @scroll="scrollCheck">
    <div class="loading-wrapper" v-if="loading">
      <LoadingWidget type="bar" ref="loading"></LoadingWidget>
    </div>

    <div v-else class="list-wrapper">
      <ListRow
        v-for="purchase in purchaseRows"
        :key="purchase.id"
        :model="purchase" />
      <LoadingWidget type="bar" ref="loadingMore" class="hide"></LoadingWidget>
    </div>
  </div>
</template>

<script>
import ListRow from '@/components/lists/ListRow'
import LoadingWidget from '@Common/elements/LoadingWidget'
import { usePurchaseStore } from '@/stores/PurchaseStore'
import { useBusinessStore } from '@/stores/BusinessStore'
import { useCategorySetStore } from '@/stores/CategorySetStore'
import { createPurchaseRows } from '@/libs/purchases'
// import { formatDateShort, formatAmount } from '@/utils/formatting'

export default {
  name: 'PurchaseList',

  setup() {
    const purchaseSet = usePurchaseStore()
    const businessSet = useBusinessStore()
    const categorySet = useCategorySetStore()

    return {
      purchaseSet,
      businessSet,
      categorySet,
    }
  },

  data() {
    return {
      detailKeys: [
        'desc',
        {
          key: 'details',
          isLink: true,
        },
      ],
      loading: true,
    };
  },

  computed: {
    purchaseRows() {
      return createPurchaseRows(this.purchaseSet.getSet)
    },

    businessList() {
      return this.businessSet.getSet.map(b => {
        return {
          ...b,
          cardData: {
            center: b.name
          }
        }
      })
    },

    categoryList() {
      return this.categorySet.getSet.map(c => {
        return {
          ...c,
          cardData: {
            center: c.name
          }
        }
      })
    },
  },

  methods: {
    scrollCheck(e) {
      const t = e.target
      if (t.scrollTop >= (t.scrollHeight - t.offsetHeight) && !!this.purchaseSet.getNextLink) {
        this.showLoading()
        this.purchaseSet.fetch(this.purchaseSet.getNextLink, true)
          .then(() => {
            this.hideLoading()
          })
      }
    },

    showLoading() {
      this.$refs.loadingMore.show()
    },

    hideLoading() {
      this.$refs.loadingMore.hide()
    },
  },

  created() {
    this.purchaseSet.fetch().then((r) => {
      this.loading = false
      return r
    })
  },

  components: {
    ListRow,
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.purchase-list-wrapper {
  height: 100%;
  overflow: auto;

  .object-links {
    margin-top: $margin;

    .link {
      color: $color-primary-dark;
      font-weight: $bold;
      text-decoration: none;
      padding: $padding;
      margin: $margin;
      width: 100%;
      text-align: center;
      border: 2px solid transparent;

      &:hover, &.selected {
        border-color: $color-primary-dark;
      }
    }
  }
}
</style>
